import { render } from "./PermissionDeniedModal.vue?vue&type=template&id=02f8a517&scoped=true"
import script from "./PermissionDeniedModal.vue?vue&type=script&lang=js"
export * from "./PermissionDeniedModal.vue?vue&type=script&lang=js"

import "./PermissionDeniedModal.vue?vue&type=style&index=0&id=02f8a517&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02f8a517"]])

export default __exports__